import { rawUrlHash } from '../../../../utils/api';
import { sfccPost } from '../../../../utils/sitegenesis';
import type { LinksToRetrieve } from '../types';

export async function getLinksUrls(
    urlMap: Record<string, string>,
    links: LinksToRetrieve[],
): Promise<Map<number, string>> {
    const urls = await Promise.all(
        links.map(
            (link): Promise<string> =>
                urlMap[rawUrlHash(link.url)]
                    ? Promise.resolve(urlMap[rawUrlHash(link.url)])
                    : sfccPost<string>('PwaUtils-Url', link.url),
        ),
    );
    const result = new Map<number, string>();
    links.forEach((link, i) => {
        result.set(link.id, urls[i]);
    });
    return result;
}
